import React, { useEffect, useState, useMemo } from 'react';
import { Box } from '@material-ui/core';
import TBarML from '../echarts/TBarML';
import PieTwoML from '../echarts/PieTwoML';
import CommonGroupStyled from '../common_group/CommonGroupStyled';
import { MenuItem, Select } from '@material-ui/core';
import { useDispatch } from 'dva';
import { useLocation } from 'umi';
import { fmtPercent } from '@/utils/comUtil';
import webStorage from '@/utils/storageManager';

// 传递给柱状图、饼状图的数据
const initData = (d, type) => {
  if (d && d.groupTagChartList && d.groupTagChartList.length > 0) {
    return d.groupTagChartList.map((item) => ({
      value: type !== 2 ? item.numberCount : item.percent,
      number: item.numberCount,
      name: item.name,
      percent: item.percent,
    }));
  }
  return [];
};
const initName = (d) => {
  if (d && d.groupTagChartList && d.groupTagChartList.length > 0) {
    return d.name;
  }
  return '';
};
const initPercent = (d) => {
  if (d && d.groupTagChartList && d.groupTagChartList.length > 0) {
    return d.percent;
  }
  return '';
};
const CommonGroup = ({ obj = null }) => {
  // 下拉框(字典项)
  const DICTOBJ = webStorage.get('DICTOBJ');
  const { PROFILE_GROUP_CHART_SELECT } = DICTOBJ || [];
  const location = useLocation();
  const { groupId } = location.query;
  const dispatch = useDispatch();
  const [data, setData] = useState();
  useEffect(() => {
    obj.tagId &&
      dispatch({
        type: 'crowPortrayal/groupTagChartList',
        payload: {
          values: {
            groupId,
            tagId: obj.tagId,
          },
        },
        callback: (res) => {
          setData(res);
        },
      });
  }, [dispatch, groupId, obj]);

  const [information, setInformation] = React.useState(
    PROFILE_GROUP_CHART_SELECT[1].dictValue,
  );
  const handleChange = (event) => {
    setInformation(event.target.value);
  };

  const dt = useMemo(() => {
    let newData = { ...data };
    if (typeof data === 'object' && data.groupTagChartList) {
      const d = [...data.groupTagChartList];
      if (d.length > information) {
        newData.groupTagChartList = d.splice(0, information);
      }
    }
    return newData;
  }, [information, data]);

  return (
    <CommonGroupStyled>
      {/* 柱状图 */}
      <Box>
        <Box className="comm_top">
          <Box>
            <div className="comm_top_left_tp">{initName(dt)}</div>
            <div className="comm_top_left_btm">
              {fmtPercent(initPercent(dt))}会员拥有 {initName(dt)} 标签
            </div>
          </Box>
          {obj.chartType === '2' && (
            <Box>
              <Select
                variant="outlined"
                label=""
                value={information}
                onChange={handleChange}
                displayEmpty
                className="comm_top_right"
              >
                {PROFILE_GROUP_CHART_SELECT.map((item, index) => (
                  <MenuItem value={item.dictValue} key={index}>
                    {item.nameZh}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}
        </Box>
        <Box>
          {obj.chartType === '2' ? (
            <Box sx={{ height: 280, width: '100%' }}>
              <TBarML height="100%" data={initData(dt, 2)} />
            </Box>
          ) : (
            <Box sx={{ width: '100%', height: 280 }}>
              <PieTwoML height="100%" data={initData(dt)} />
            </Box>
          )}
        </Box>
      </Box>
    </CommonGroupStyled>
  );
};

export default CommonGroup;
